import ApiService from './ApiService'

const UnitService = {
    async get(unit) {
        try {
            const { data } = await ApiService.get('unit.show', unit)

            const connectivity_settings = data.connectivity_settings || null
            const notes = data.notes || null
            const unit_type_options = data.unit_type_options || []

            const {
                connectivity_settings: _,
                notes: __,
                unit_type_options: ___,
                ...unitData
            } = data

            return {
                connectivity_settings,
                notes,
                unit_type_options,
                unitData,
            }
        } catch (error) {
            console.error('Error fetching unit data:', error)
            throw error
        }
    },

    update(unit, data) {
        return ApiService.post('unit.update', data, unit)
    },

    saveConnectivity(unit, data) {
        return ApiService.post('unit.update_connectivity', data, unit)
    },

    getUseData(unit, grouping) {
        return ApiService.get('unit.use_data_chart', [unit, grouping])
    },

    getBaseInfo(unit) {
        return ApiService.get('unit.use_data_base_info', unit)
    },

    downloadUnitUseExport(filename, params) {
        return ApiService.downloadFile('unit.use_data_export', filename, params)
    },
}

export default UnitService
